import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoAccountSessionLogListRequest,
  PerplayLogApi
} from '../../models/src';
import { SESSIONLOG_LIST_REQUEST } from '../../constants/log/sessionLogConstants';
import {
  sessionLogList,
  setSessionLogPagination,
} from '../../actions/log/sessionLogActions';
import { setTotalCount } from '../../actions/log/gameSessionLogActions';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoAccountSessionLogListResponse
  from '../../models/src/model/LogControllerDtoAccountSessionLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* sessionLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoAccountSessionLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.searchString = payload.searchString;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogAccountSessionLogListPost({ logControllerDtoAccountSessionLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoAccountSessionLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    yield put(sessionLogList(data.list));
    yield put(setTotalCount(data.totalCount));
    yield put(
      setSessionLogPagination(
        payload.page,
        data.totalCount,
        payload.beginDate,
        payload.endDate,
        payload.searchString,
      ));
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* sessionLogRootSaga() {
  yield all([takeEvery(SESSIONLOG_LIST_REQUEST, sessionLogListRequestSaga)]);
}

const sessionLogSagas = [fork(sessionLogRootSaga)];

export default sessionLogSagas;
